export default (function () {
  var _head = document.getElementsByTagName("head")[0], _js, _eventHandlerLoad, _eventHandlerError;
  function loadScript(path, cb, args, charset) {
    //和后端建立长连接
    _js = document.createElement("script")
    _eventHandlerLoad = function () {
      removeScript();
      typeof cb == "function" && cb(args, true);
    };
    _eventHandlerError = function () {
      removeScript();
      typeof cb == "function" && cb(args, false);
    };

    _js.addEventListener("load", _eventHandlerLoad);
    _js.addEventListener("error", _eventHandlerLoad);
    _js.charset = charset || "utf-8";
    _js.src = path;
    _head.insertBefore(_js, _head.firstChild);
  }

  function removeScript() {
    if (!_js) {
      return;
    }
    try {
      _js.src = "";
    } catch (_) {
    }
    _js.removeEventListener("load", _eventHandlerLoad);
    _js.removeEventListener("error", _eventHandlerError);
    _head.removeChild(_js);
    _js = null;
    _eventHandlerLoad = null;
    _eventHandlerError = null;
  }
  return {
    _uuid: null,
    /**
     * @param {String} opt.uuid
     * @param {String} opt.openid
     * @param {String} opt.openkey
     * @param {Function} opt.onSuccess
     * @param {Boolean} opt.sandbox 表示是否是沙箱环境
     */
    start: function (opt) {
      //每次只能开启一个连接
      this.cancel();
      var that = this;
      this._uuid = opt.uuid;
      var hander = function (response) {
        switch (parseInt(response, 10)) {
          case 0: //要继续请求
            that.start(opt);
            break;
          case 1: //正在支付。这个先不要用
            that.cancel();
            break;
          case 1000: //支付成功
            that.cancel();
            opt.onSuccess && opt.onSuccess();
            break;
        }
      };

      this._cb = 'XDomainRequest' + Math.floor(Math.random() * 10000);
      var res;
      window[this._cb] = function (_res) {
        res = _res;
      };

      loadScript('//' + (opt.sandbox ? 'sandbox.' : '') + 'jspay.qq.com/jsonp?uin=' + opt.openid + '&skey=' + opt.openkey + '&uuid=' + this._uuid + '&cb=' + this._cb + '&junhan=' + Math.random(), function (args, isLoaded) {
        if (isLoaded) {
          hander(res);
        }
      });
    },
    cancel: function () {
      if (this._uuid) {
        this._uuid = null;
      }
      if (this._cb) {
        window[this._cb] = function () { };
        this._cb = null;
      }

      removeScript();
    }
  }
})()
